import { useMyAccountContext } from "../../Contexts/MyAccountContext";
import Button from "../../Components/Button";
import { Modal } from "@mui/material";
import PropTypes from "prop-types";

const Alert = ({ open, onClose }) => {
  const { resetValues, showModal, navigate, type } = useMyAccountContext();

  const handleContinue = () => {
    onClose();
    navigate("/my-account/update-details");
    resetValues();
  };

  return (
    <Modal
      open={showModal}
      onClose={onClose}
      sx={{ display: "flex", overflow: "auto", backdropFilter: "blur(8px)" }}
    >
      <div className="sm:w-89.5 w-72 bg-white m-auto rounded-2xl p-6">
        <p className="text-center text-xl font-semibold mb-4">
          Confirm {type} update
        </p>
        <p className="text-[#60656D] text-center mb-4">
          You're about to update your {type}. This change will be reflected in
          your account and used for future logins. Are you sure you want to
          proceed?
        </p>
        <div className="flex">
          <Button
            className={`w-full h-10 rounded-xl font-semibold mt-2 transition ease-in-out delay-75 hover:scale-105 bg-white text-black border`}
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            className="w-full h-10 rounded-xl font-semibold mt-2 bg-[#0947AB] text-white transition ease-in-out delay-75 hover:scale-105 ml-2"
            onClick={handleContinue}
          >
            Yes, continue
          </Button>
        </div>
      </div>
    </Modal>
  );
};

Alert.propTypes = {
  open: PropTypes.bool.isRequired, 
  onClose: PropTypes.func.isRequired, 
};

export default Alert;
